export const placeholdersToRemove = [
  "[Your Name]",
  "[City, State, Zip Code]",
  "[Your Address]",
  "[City, State ZIP Code]",
  "[Email Address]",
  "[City, Province, Postal Code]",
  "[City, Province/State, Postal Code]",
  "[Employer's Name]",
  "[Phone Number]",
  "[Today’s Date]",
  "[Date]",
  "[Hiring Manager's Name]",
  "[City, State, ZIP Code]",
  "[Today's Date]",
  "[Today’s Date]",
  "[number]",
  "[Company Address]",
  "[platform/job board]",
  "[City, State ZIP Code]",
  "[City, State, Zip]",
  "[Recipient's Name]",
  "[Recipient's Job Title]",
  "[City, State, ZIP]",
  "[Company Name]",
  "[Your Email Address]",
  "[Address]",
];
